export const MODULE_NAME = 'xen:macro';
export const EXTENSION_NAMESPACE = 'com.atlassian.ecosystem';
export const P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
export const CONNECT_ADDON_ACTION_SUBJECT = 'connectAddon';
export const MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT = 'migratedServerP2Addon';
export const EXTENSION_TYPE_BODIED = 'bodiedExtension';
export const EXTENSION_TYPE_MULTI_BODIED = 'multiBodiedExtension';
export const FORGE_EXTENSION = 'forge.ui.extension';
export const FORGE_DOC_UPDATED_EVENT = 'forgeDocUpdated';
